// extracted by mini-css-extract-plugin
export default {"overlay":"Backdrop_overlay__syIJZ"};